import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../api';

interface Props {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<Props> = ({ children }) => {
  if (!isAuthenticated() || !isAdmin()) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return <>{children}</>;
};

export default AdminProtectedRoute;
